import React, { useState, useEffect, useMemo } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import { useToasts } from "react-toast-notifications";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import SelectElement from "components/Elements/SelectElement/SelectElement.js";
import Button from "components/Elements/Button/Button.js";
import Image from "components/Elements/Image/Image.tsx";

const JumboPayInvoiceDetails = ({ userFullDetails }) => {
  const { getUserData } = useUser();
  const userData = getUserData();
  const { getTextByKey } = useContent();
  const { addToast } = useToasts();

  const [displayName, setDisplayName] = useState("");
  const [loadingSaveDisplayName, setLoadingSaveDisplayName] = useState(false);

  const handleChangeDisplayName = (e) => {
    setDisplayName(e);
  };

  const [loadingSaveInvoiceDetails, setLoadingSaveInvoiceDetails] =
    useState(false);
  const [countries, setCountries] = useState([]);
  const [countriesListDropDown, setCountriesListDropDown] = useState([]);
  const [invoiceName, setInvoiceName] = useState("");
  const [invoicePhone, setinvoicePhone] = useState("");
  const [invoiceCountry, setInvoiceCountry] = useState(null);
  const [invoiceCountryForDB, setInvoiceCountryForDB] = useState("");
  const [invoiceIdNumber, setInvoiceIdNumber] = useState("");
  const [invoiceEmailAddress, setInvoiceEmailAddress] = useState("");

  const handleChangeInvoiceName = (e) => {
    setInvoiceName(e);
  };

  const handleChangeInvoicePhone = (e) => {
    setinvoicePhone(e);
  };

  const handleChangeInvoiceCountry = (e) => {
    setInvoiceCountry(e);
  };

  const handleChangeInvoiceIdNumber = (e) => {
    setInvoiceIdNumber(e);
  };

  const handleChangeInvoiceEmailAddress = (e) => {
    setInvoiceEmailAddress(e);
  };

  const invoiceValues = [
    {
      text: "payment-billing-info-name",
      value: invoiceName,
      onChange: handleChangeInvoiceName,
    },
    {
      text: "phone",
      value: invoicePhone,
      onChange: handleChangeInvoicePhone,
    },
    {
      text: "profileuserdetails-country",
      value: invoiceCountry,
      onChange: handleChangeInvoiceCountry,
    },
    {
      text: "invoice-id-number",
      value: invoiceIdNumber,
      onChange: handleChangeInvoiceIdNumber,
    },
    {
      text: "invoice-email-address",
      value: invoiceEmailAddress,
      onChange: handleChangeInvoiceEmailAddress,
      tooltipText: "invoice-email-address-tooltip",
    },
  ];

  const saveInvoiceDetails = async () => {
    if (loadingSaveInvoiceDetails) {
      return;
    }

    setLoadingSaveInvoiceDetails(true);

    const body = {
      Billing_Name: invoiceName,
      Billing_PhoneNumber: invoicePhone,
      Billing_EmailAddress: invoiceEmailAddress,
      UserMail: userData.UserName,
      Billing_Country: invoiceCountryForDB.countryKey,
      Billing_Vat: Number(invoiceIdNumber),
    };
    const response = await apiRequest(
      "Users",
      "EditInvoiceInfoReact",
      body,
      "POST"
    );
    if (response.status === "success") {
      addToast(getTextByKey("invoice-details-saved"), {
        appearance: "success",
      });
      setLoadingSaveInvoiceDetails(false);
    }
  };

  const saveDisplayNameApi = async () => {
    setLoadingSaveDisplayName(true);
    const body = {
      DefaultDisplayName: displayName,
      Users_Email: userData.UserName,
    };
    const response = await apiRequest(
      "Users",
      "ChangeDisplayNameReact",
      body,
      "POST"
    );
    if (response.status === "success") {
      addToast(getTextByKey("display-name-saved"), {
        appearance: "success",
      });
      setLoadingSaveDisplayName(false);
    }
  };

  const returnInvoiceInput = (item, index) => {
    return (
      <div className="input-div" key={index}>
        <span className="input-span">{getTextByKey(item.text)}</span>
        <div className="input-and-tooltip">
          {item.text === "invoice-country" ? (
            <div className="countries-dropdown">
              {invoiceCountry !== null && (
                <SelectElement
                  item={invoiceCountry}
                  setItem={setInvoiceCountry}
                  list={countriesListDropDown}
                />
              )}
            </div>
          ) : (
            <>
              <input
                type="text"
                value={item.value}
                onChange={(e) => item.onChange(e.target.value)}
              />
              {item.tooltipText ? (
                <Tooltip
                  id={item.tooltipText}
                  tooltipTextKey={item.tooltipText}
                >
                  <Icon name="question-circle" iconClass="tooltip-question" />
                </Tooltip>
              ) : null}
            </>
          )}
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (userFullDetails) {
      setDisplayName(
        userFullDetails.DefaultDisplayName
          ? userFullDetails.DefaultDisplayName
          : ""
      );
      if (userFullDetails.User_InvoiceInfo) {
        const userCountry = userFullDetails.User_InvoiceInfo.Billing_Country;
        if (userCountry && countries.length > 0) {
          const country = countries.find(
            (country) =>
              country.countryKey.toLowerCase() === userCountry.toLowerCase()
          );
          setInvoiceCountry(country.countryKey ? country.countryKey : "");
          setInvoiceCountryForDB(country);
        }
        setinvoicePhone(
          userFullDetails.User_InvoiceInfo.Billing_PhoneNumber
            ? userFullDetails.User_InvoiceInfo.Billing_PhoneNumber
            : ""
        );
        setInvoiceName(
          userFullDetails.User_InvoiceInfo.Billing_Name
            ? userFullDetails.User_InvoiceInfo.Billing_Name
            : ""
        );
        setInvoiceIdNumber(
          userFullDetails.User_InvoiceInfo.Billing_Vat
            ? userFullDetails.User_InvoiceInfo.Billing_Vat
            : 0
        );
        setInvoiceEmailAddress(
          userFullDetails.User_InvoiceInfo.Billing_EmailAddress
            ? userFullDetails.User_InvoiceInfo.Billing_EmailAddress
            : ""
        );
      }
    }
  }, [userFullDetails, countries]);

  //Get all Countries list
  const getCountries = async () => {
    const parameters = {
      culture: "en",
    };
    const response = await apiRequest(
      "Dictionaries",
      "GetCountries",
      parameters
    );
    if (response.status === "success") {
      setCountries(response.data);
      //get only the countryValue from the response.data
      const countryValue = response.data.map((item) => item.countryKey);
      setCountriesListDropDown(countryValue);
      //setCountries(correctArray);
    }
  };

  useMemo(() => {
    getCountries();
  }, []);

  return (
    <>
      <div className="display-name-input">
        <div className="display-name-container">
          <div className="input-div">
            <span className="input-span">
              {getTextByKey("displayname-label-text")}
            </span>
            <div className="input-and-tooltip">
              <input
                type="text"
                value={displayName}
                onChange={(e) => handleChangeDisplayName(e.target.value)}
              />
              <Tooltip
                id={"display-name-tooltip"}
                tooltipTextKey="display-name-tooltip"
              >
                <Icon name="question-circle" iconClass="tooltip-question" />
              </Tooltip>
            </div>
          </div>
          <div className="actions">
            <Button className="new-button" onClick={() => saveDisplayNameApi()}>
              {loadingSaveDisplayName ? (
                <Image name="preloader" ext="gif" />
              ) : (
                getTextByKey("save")
              )}
            </Button>
          </div>
        </div>
      </div>
      <div className="invoice-details">
        <h4>{getTextByKey("payment-billing-info")}</h4>
        <div className="invoice-details-container">
          <div className="left">
            {countries &&
              invoiceValues.map((item, index) =>
                index % 2 === 0 ? returnInvoiceInput(item, index) : null
              )}
          </div>
          <div className="right">
            {" "}
            {countries &&
              invoiceValues.map((item, index) =>
                index % 2 !== 0 ? returnInvoiceInput(item, index) : null
              )}
          </div>
        </div>
        <div className="actions">
          <Button className="new-button" onClick={() => saveInvoiceDetails()}>
            {loadingSaveInvoiceDetails ? (
              <Image name="preloader" ext="gif" />
            ) : (
              getTextByKey("save")
            )}
          </Button>
        </div>
      </div>
    </>
  );
};

export default JumboPayInvoiceDetails;
